var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ display: _vm.played ? 'flex': 'none' })},[_c('IconMusic',{attrs:{"fill":"#B0B0B0"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }